// @flow
/**
 * @module Sagas/PublicPages/LandingPage
 * @desc Public Pages LandingPage related sagas
 */
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as PublicPagesConstants from "../../Constants/PublicPages/publicPagesConstants";
import * as api from "../../Api/PublicPages/landingpage";

/**
 * Landing Page Logos & Testimonials
 */
export function* landingPageLogosRequest(): Object {
  try {
    const response = yield call(api.fetchLandingPageLogos());
    const { status, data } = response;
    if (status === 200) {
      yield put({
        type: PublicPagesConstants.LANDING_PAGE_LOGOS_SUCCESS,
        payload: { data }
      });
    } else {
      yield put({
        type: PublicPagesConstants.LANDING_PAGE_LOGOS_FAILURE
      });
    }
  } catch (err) {
    yield put({
      type: PublicPagesConstants.LANDING_PAGE_LOGOS_FAILURE
    });
  }
}

export function* landingPageTestimonialsRequest(): Object {
  try {
    const response = yield call(api.fetchLandingPageTestimonials());
    const { status, data } = response;
    if (status === 200) {
      yield put({
        type: PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_SUCCESS,
        payload: { data }
      });
    } else {
      yield put({
        type: PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_FAILURE
      });
    }
  } catch (err) {
    yield put({
      type: PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_FAILURE
    });
  }
}

/**
 * Landing Page Sagas Connector
 */
export default function* root(): Object {
  yield all([
    takeLatest(PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_REQUEST, landingPageTestimonialsRequest),
    takeLatest(PublicPagesConstants.LANDING_PAGE_LOGOS_REQUEST, landingPageLogosRequest),
  ])
}


// WEBPACK FOOTER //
// ./src/Sagas/PublicPages/landingpage.js